<template>
  <div style="position: relative;">
    <div class="content">
      <div class="title-text">
        <p class="title">
          Features and Feedback
        </p>
        <p class="subtitle">Help shape the future of ArtistHub by sharing your thoughts and ideas.</p>
      </div>
      <div class="card" style="background: #121212;"><div data-canny /></div>
    </div>
  </div>
</template>

<script>
const BoardToken = 'fe96c28b-9660-d9e1-dc98-ee23a31b757c';

export default {
  mounted() {
    (function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}})(window,document,"canny-jssdk","script");

    window.Canny('render', {
      boardToken: BoardToken,
      basePath: '/feedback', // See step 2
      theme: 'dark', // options: light [default], dark, auto
    });
  }
}
</script>
<style lang="scss" scoped>
.suspended-artist {
  flex: 1;
  display: flex;
  flex-direction: row;
  background: #d6a654;
  border-radius: 10px;
  padding: 12px 24px;
  margin-bottom: 36px;
  .artist-details {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: white;
      mix-blend-mode: normal;
    }
  }
}
.billing-card {
  display: grid;
  grid-gap: 24px;
  margin-bottom: 36px;
  padding: 24px;
  /* BG/type2 */
  background: #24224a;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: #ffffff;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: #b1afcd;
      mix-blend-mode: normal;
      opacity: 0.9;
      .bold {
        font-weight: 600;
        //color: white;
      }
    }
  }
  .card-content {
    display: grid;
    grid-gap: 24px;
    .payment-container {
      width: 100%;
      .payment-footer {
        padding-top: 10px;
        display: flex;
        button {
          margin-left: auto;
        }
      }
    }
    .braintree-billing {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .payment {
        width: 100%;
        .button-default {
          //margin-top: -44px;
          padding: 9px 30px;
          float: right;
        }
      }
    }
  }
  .next-charge {
    background: $bg-type-1;
    border-radius: 10px;
    padding: 12px 24px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    .date {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .span {
        /* 16/SemiBold */
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
    }
    .details {
      display: flex;
      flex-direction: column;
      text-align: right;
      .total {
        /* 16/SemiBold */
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
      .subscription {
        /* 12/Regular */
        font-size: 14px;
        /* Text/type0 */
        color: $text-type-0;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
    }
  }
  .billing-interval {
    display: flex;
    justify-content: space-evenly;
    .element {
      display: flex;
      flex-direction: column;
      background: $bg-type-1;
      width: 45%;
      padding: 22px 0;
      align-items: center;
      border-radius: 10px;
      &.selected {
        border: 1px solid #be3bff;
      }
      &:hover {
        cursor: pointer;
      }
      .title {
        /* 16/SemiBold */
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
      .subtitle {
        /* 12/Regular */
        font-size: 14px;
        /* Text/type0 */
        color: $text-type-0;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
    }
  }
  .artists,
  .invoices {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 18px;
    .artist,
    .invoice {
      flex: 1;
      display: flex;
      flex-direction: row;
      background: $bg-type-1;
      border-radius: 10px;
      padding: 12px 24px;
      .artist-details,
      .payment-method {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 100px;
          margin-right: 16px;
        }
        svg {
          margin-right: 16px;
        }
        .name {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: white;
          mix-blend-mode: normal;
        }
        .details {
          display: flex;
          flex-direction: column;
          .title {
            /* 16/SemiBold */
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            /* White */
            color: white;
            mix-blend-mode: normal;
            opacity: 0.9;
          }
          .subtitle {
            /* 12/Regular */
            font-size: 14px;
            /* Text/type0 */
            color: $text-type-0;
            mix-blend-mode: normal;
            opacity: 0.9;
          }
        }
      }
    }
    .subscription {
      display: flex;
      align-items: center;
      .status {
        /* 16/SemiBold */
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        margin-right: 24px;
      }
      .suspended {
        color: #e79c9c;
      }
      .suspended-active {
        color: #e79c9c;
        margin-right: 5px;
      }
      .invoice-date {
        margin: 0 40px;
      }
      .details {
        display: flex;
        flex-direction: column;
        text-align: right;
        margin-right: 24px;
        .total {
          /* 16/SemiBold */
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          /* White */
          color: white;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
        .subscriptions {
          /* 12/Regular */
          font-size: 14px;
          /* Text/type0 */
          color: $text-type-0;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
      }
      button {
        max-height: 50px;
        span {
          margin-left: 6px;
          margin-top: 2px;
        }
        svg {
          margin: 0;
        }
      }
    }
  }
}
</style>
